<template>
  <div class="input">
    <div class="input-label">ヒント</div>
    <div class="input-group">
      <input type="text" class="input-text" v-model="hint">
    </div>
  </div>
</template>

<script>
export default {
  computed: {
    hint: {
      get: function () {
        return this.$store.state.quiz.hint
      },
      set: function (value) {
        this.$store.commit(
          'quiz/setHint',
          value
        )
      }
    }

  }
}
</script>

<style lang="scss" scoped>
@import '@/styles/_form.scss';
</style>
